<div class="space-children-mr">
  <a [ngClass]="{'btn-sm': small}" class="btn btn-light my-1 delete-link" [routerLink]="[getDeleteRoute()]" [title]="'admin.workflow.item.delete' | translate">
    <i class="fa fa-trash"></i>@if (!small) {
    <span class="d-none d-sm-inline"> {{"admin.workflow.item.delete" | translate}}</span>
  }
</a>
<a [ngClass]="{'btn-sm': small}" class="btn btn-light my-1 send-back-link" [routerLink]="[getSendBackRoute()]" [title]="'admin.workflow.item.send-back' | translate">
  <i class="fa fa-hand-point-left"></i>@if (!small) {
  <span class="d-none d-sm-inline"> {{"admin.workflow.item.send-back" | translate}}</span>
}
</a>
</div>
